/* eslint-disable max-len */

enum ERROR_TEXTS {
  UNABLE_TO_CONNECT = 'Unable to connect to the server to get ticker data. The server may have stopped working.',
}

export default ERROR_TEXTS;
